import { useState } from 'react'

function getIsApple(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent
  const hasAppleMobileUA = /iPad|iPhone|iPod/.test(ua)
  const isIPadOS13Plus = /Mac/.test(ua) && navigator.maxTouchPoints > 1
  const isMac = /Mac/.test(ua) && navigator.maxTouchPoints <= 1
  return hasAppleMobileUA || isIPadOS13Plus || isMac
}

export function useIsApple(): boolean {
  const [isApple] = useState(getIsApple)
  return isApple
}

export default useIsApple
